import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin
} from 'antd'
import IntlMessages from '../../util/IntlMessages'
import ds from '../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import ProductType from '../../assets/images/product-types.png'
import AddProductType from '../../components/AddProductType'
import { useStore, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { loadData } from '../../appRedux/actions/Setting'
import { useSelector } from 'react-redux'
import { setCommonConfigs } from '../../appRedux/actions/CommonData'
import { PRODUCTTYPE } from '../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
// import { REACT_APP_BUS_FIRST_NAME } from '../../constants/StoreSetting'
import { TableName } from '../../constants/TableName'
import { env } from '../../env'

const { REACT_APP_BUS_FIRST_NAME } = env
const Panel = Collapse.Panel
const confirm = Modal.confirm

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const ProductTypes = ({ match }) => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [getProductTypeID, setProductTypeID] = React.useState(0)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [visible, setVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [getTableData, setTableData] = React.useState([])
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getPagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10
  })

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(PRODUCTTYPE))
      let body = { CurrentPageNo: getPagination.current }
      getProductTypesData(body)
    }

    return () => (mounted = false)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  async function getProductTypesData (body) {
    setIsLoading(true)
    const getTypeData = ds.getProductTypes(body, BEHAVIOUR_TYPE.GET)
    await getTypeData
      .then(response => {
        if (response.data.data != null) {
          let mapped = response.data.data.map(prodtypes => {
            return {
              key: prodtypes.productTypeID,
              name: prodtypes.name,
              productTypeIDEncyp: prodtypes.productTypeIDEncrypted,
              numofproducts: prodtypes.nbrOfProducts
            }
          })

          setTableData(mapped)
          let paginationObj = {
            current: body.CurrentPageNo,
            pageSize: getPagination.pageSize,
            total:
              response.data.data.length > 0
                ? response.data.data[0].totalRecords
                : 0
          }
          setPagination(paginationObj)
          setIsLoading(false)
          setSpinningLoading(false)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
      })
  }
  const columns = [
    {
      title: <IntlMessages id='products.productypes.name' />,
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: <IntlMessages id='products.productypes.noofproducts' />,
      dataIndex: 'numofproducts',
      key: 'numofproducts'
    },
    {
      title: <IntlMessages id='products.brands.viewproduct' />,
      key: 'viewproduct',
      render: (text, record) => {
        //const [form] = Form.useForm();
        const viewProduct = async () => {
          history.push(
            `/dashboard/products/main/listing/typeid/${record.productTypeIDEncyp}`
          )
        }
        return (
          <div>
            <span>
              <a onClick={() => viewProduct(record.key)} className='gx-link'>
                <IntlMessages id='products.productypes.viewproduct' />
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='products.productypes.edit' />,
      key: 'edit',
      render: (text, record) => {
        //const [form] = Form.useForm();
        const editProductTypes = async (productTypeID, productTypeName) => {
          setVisible(true)
          setProductTypeID(productTypeID)
          form.setFieldsValue({ ProductTypeNameEdit: productTypeName })
        }
        return (
          <div>
            <span>
              <a
                onClick={() =>
                  editProductTypes(record.key, record.name, record.description)
                }
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='products.productypes.delete' />,
      key: 'delete',
      render: (text, record) => {
        const deleteProductType = async productTypeID => {
          let addUpdateDeleteProductType = {
            data: {
              msgCode: '',
              msgDescription: ''
            }
          }
          await ds
            .addUpdateDeleteProductType(
              {
                ProductTypeID: productTypeID,
                IsRemove: true
              },
              BEHAVIOUR_TYPE.DELETE
            )
            .then(response => (addUpdateDeleteProductType.data = response.data))
            .catch(e => notAllowMsgCheck(e))

          if (addUpdateDeleteProductType.data.msgCode == 'GENERAL_SUCCESS') {
           // message.success(addUpdateDeleteProductType.data.msgDescription)
            message.success("Product Type deleted successfully !")
            setTimeout(() => {
              window.location.href = "/Dashboard/products/ProductTypes";
            }, 1000)
          }

          if (addUpdateDeleteProductType.data.msgCode == 'GENERAL_ERROR') {
            message.error(addUpdateDeleteProductType.data.msgDescription)
          }
        }

        function showDeleteConfirm (productTypeID, productTypeName) {
          confirm({
            title: 'Are you sure delete this Product Type?',
            content: `"${productTypeName}"`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { className: 'dk-btn-add close-reg-btn' },
            cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
            onOk () {
              deleteProductType(productTypeID)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }

        return (
          <span>
            <a
              onClick={() => showDeleteConfirm(record.key, record.name)}
              className='trash-icon-btn'
            >
              {/* <IntlMessages id="products.productypes.delete" /> */}
              <i className='icon icon-trash' />
            </a>
          </span>
        )
      }
    }
  ]
  const handleOk = () => {
    setConfirmLoading(true)
    setTimeout(() => {
      setVisible(false)
      setConfirmLoading(false)
    }, 2000)
  }
  const handleCancel = () => {
    console.log('Clicked cancel button')
    setVisible(false)
  }
  const onFinishFailed = errorInfo => {
    message.error(<IntlMessages id='products.productypes.failedproducttype' />)
  }
  const onFinish = async values => {
    // ;
    setVisible(false)
    setSpinningLoading(true)

    form.getFieldValue('TypeName')
    //This message set using api
    // message.success("Successfully added " + form.getFieldValue("TypeName"));

    let addUpdateDeleteProductType = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .addUpdateDeleteProductType(
        {
          ProductTypeID: getProductTypeID,
          ProductTypeName: values.ProductTypeNameEdit,
          ProductTypeDescription: '',
          IsRemove: false
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(response => {
        addUpdateDeleteProductType.data = response.data
        getProductTypesData()
        message.success(response.data.msgDescription + ' Product Type')
        let body = { CurrentPageNo: getPagination.current }
        getProductTypesData(body)
      })
      .catch(e => notAllowMsgCheck(e))

    if (addUpdateDeleteProductType.data.msgCode == 'GENERAL_SUCCESS') {
      dispatch(loadData(true))
      setTimeout(() => {
         window.location.href = "/Dashboard/products/ProductTypes";
      }, 1000)
    }

    if (addUpdateDeleteProductType.data.msgCode == 'GENERAL_ERROR') {
      setSpinningLoading(false)
      message.error(addUpdateDeleteProductType.data.msgDescription)
    }
    setTimeout(() => {
      setSpinningLoading(false)
    }, 2000)
  }
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.ProductTypes,
      SearchValue: value,
      ID: `${getProductTypeID}&&_bd98-6131-47dd-8ac8-4bd1856d2a60`
    }
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback('This Product Type name exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }
  const EditModal = () => {
    return (
      <div>
        <Modal
          title={<IntlMessages id='products.productypes.newproducttype' />}
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          centered={true}
          width={'402px'}
          className='New-Product-Type-Modal'
          footer={
            <>
              <Button
                form='productTypeEdit'
                className='custom-searchbtn'
                type='primary'
                htmlType='submit'
              >
                <IntlMessages id='products.productypes.edit' />
              </Button>
            </>
          }
        >
          <Form
            {...formItemLayout}
            form={form}
            name='productTypeEdit'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86'
            }}
            scrollToFirstError
          >
            <Form.Item
              className='form-inner-pad-0'
              name='ProductTypeNameEdit'
              label={
                <span>
                  <strong>
                    <IntlMessages id='products.productypes.typename' />
                  </strong>
                  <Tooltip title='Type Name'></Tooltip>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: 'Please enter type name',
                  whitespace: true
                },
                {
                  validator: valideDuplicateName
                }
              ]}
            >
              <Input placeholder='Type Name' />
            </Form.Item>
            <Row style={{ marginRight: 0 }} justify='end'>
              <Col></Col>
            </Row>
          </Form>
        </Modal>
      </div>
    )
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    let body = { CurrentPageNo: pagination.current }
    getProductTypesData(body)
  }
  return (
    <div>
      <Spin
        tip={<IntlMessages id='products.productypes.addtype' />}
        spinning={isSpinningLoading}
        size='large'
      >
        <div className='Content-wrapper ProductTypes-pg'>
          <Row className='align-items-center justify-content-center mb-3 ProductTypes-header'>
            <Col lg={12} md={12} sm={24} xs={24}>
              <h1 className='mb-0'>
                <IntlMessages id='products.productypes.productypes' />
              </h1>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <div className='pg-header-btn'>
                <AddProductType />
              </div>
            </Col>
          </Row>

          <Card className='gx-card' title=''>
            <Collapse>
              <Panel
                className='custom-promolist-help'
                showArrow={false}
                header={
                  <IntlMessages id='products.productypes.needhelpheading' />
                }
              >
                <Row>
                  <div className='billing-main'>
                    <Col className='custom-promolist-helpdesc' md={12}>
                      <p>
                        <IntlMessages
                          id='products.productypes.needhelpdescription1'
                          values={{
                            strong: chunks => <strong>{chunks}</strong>,
                            bus_name_first: REACT_APP_BUS_FIRST_NAME
                          }}
                        />
                      </p>
                      <p>
                        <IntlMessages id='products.productypes.needhelpdescription2' />
                      </p>
                    </Col>

                    <Col md={12}>
                      <img src={ProductType} alt='' />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <div className='tab-body-parent'>
            <Card>
              {isLoading ? (
                <Skeleton count={7} height={35} />
              ) : (
                <Table
                  className='gx-table-responsive'
                  columns={columns}
                  dataSource={getTableData}
                  pagination={getPagination}
                  onChange={handleTableChange}
                />
              )}
              <EditModal />
            </Card>
          </div>
        </div>
      </Spin>
    </div>
  )
}

export default ProductTypes
